export const SET_BESPOKES = 'SET_BESPOKES'
export const RESET_BESPOKES = 'RESET_BESPOKES'
